<template>
  <div>
    <v-card
      v-if="stat"
      outlined
      class="mb-2"
    >
      <v-card-title>Общая статистика</v-card-title>
      <v-card-text>
        <v-row>
          <v-col md="4">
            <h3 class="mb-2">Учреждения</h3>
            <ul>
              <li>Количество подключенных школ: {{ connectedSchools }}</li>
              <li>Количество школ: {{ allSchools }}</li>
              <li>Количество муниципалитетов: {{ allMunicipalities }}</li>
            </ul>
          </v-col>
          <v-col md="2">
            <h3 class="mb-2">Всего</h3>
            <ul>
              <li>В школе: {{ stat.users.in_unit }}</li>
              <li>Выдано карт: {{ stat.users.all_cards }}</li>
              <li>С картой: {{ stat.users.with_card }}</li>
              <li>Пользователей: {{ stat.users.all }}</li>
            </ul>
          </v-col>
          <v-col md="2">
            <h3 class="mb-2">Ученики</h3>
            <ul>
              <li>В школе: {{ stat.pupils.in_unit }}</li>
              <li>Выдано карт: {{ stat.pupils.all_cards }}</li>
              <li>С картой: {{ stat.pupils.with_card }}</li>
              <li>Всего: {{ stat.pupils.all }}</li>
            </ul>
          </v-col>
          <v-col md="2">
            <h3 class="mb-2">Учителя</h3>
            <ul>
              <li>В школе: {{ stat.teachers.in_unit }}</li>
              <li>Выдано карт: {{ stat.teachers.all_cards }}</li>
              <li>С картой: {{ stat.teachers.with_card }}</li>
              <li>Всего: {{ stat.teachers.all }}</li>
            </ul>
          </v-col>
          <v-col md="2">
            <h3 class="mb-2">Гости</h3>
            <ul>
              <li>В школе: {{ stat.guests.in_unit }}</li>
              <li>Выдано карт: {{ stat.guests.all_cards }}</li>
            </ul>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row>
      <v-col md="4" v-for="route in allRoutes" :key="route.name">
        <h2 class="mb-2">{{ route.meta.label }}</h2>
        <v-card>
          <v-list dense class="pa-0">
            <template v-for="(item, index) in route.children">
              <v-list-item :key="index" :to="{ name: item.name }">
                <v-list-item-content>
                  <v-list-item-title class="pa-2 cursor-pointer">
                    {{ item.meta.label }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>navigate_next</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="index + 1 < route.children.length"
                :key="index+'divider'"
              />
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { GET_GLOBAL_STATISTICS } from '@/requests/superadmin'
import Routes from '@/router/superadmin'

export default {
  name: 'MainSuperAdminView',
  data() {
    return {
      routes: Routes.children.filter(r => r.path !== ''),
      stat: null,
      allMunicipalities: 0,
      connectedSchools: 0,
      allSchools: 0
    }
  },
  mounted() {
    this.getGlobalStat()
  },
  computed: {
    simpleRoutes() {
      return this.routes.filter(r => !r.children)
    },
    routesWithChildren() {
      return this.routes.filter(r => r.children)
    },
    allRoutes() {
      return [{
        name: 'all',
        meta: { label: 'Общее' },
        children: this.simpleRoutes,
      }, ...this.routesWithChildren]
    }
  },
  methods: {
    async getGlobalStat() {
      try {
        const { data } = await GET_GLOBAL_STATISTICS()
        this.stat = data.stat
        this.allMunicipalities = data.all_municipalities
        this.allSchools = data.all_schools
        this.connectedSchools = data.connected_schools
      } catch (error) {
        console.error(error)
        // this.$notify({
        //   type: 'error',
        //   text: 'Не удалось загрузить общую статистику'
        // })
      }
    }
  }
}
</script>
